define('implementations',{
	"enquire": [{
		isAvailable: function() {
			return ("matchMedia" in window) && "undefined" !== (typeof Modernizr) && Modernizr.mq('only all');
		},

		implementation: 'enquire'
	}, {
		isAvailable: function() {
			return Modernizr.mq('only all');
		},

		implementation: 'depend!enquire[media-match]'
	}, {
		isAvailable: true,

		module: function() {
			function isFunction(target) {
				return typeof target === 'function';
			}

			function isArray(target) {
				return Object.prototype.toString.apply(target) === '[object Array]';
			}

			function each(collection, fn) {
				var i      = 0,
					length = collection.length,
					cont;

				for(i; i < length; i++) {
					cont = fn(collection[i], i);
					if(cont === false) {
						break; //allow early exit
					}
				}
			}

			function Shim () {}
			Shim.prototype = {
				register : function(q, options, shouldDegrade) {
					if (shouldDegrade) {
						//normalise to object in an array
						if (isFunction(options)) {
							options = { match : options };
						}
						if (!isArray(options)) {
							options = [options];
						}
						each(options, function(handler) {
							if (isFunction(handler)) {
								handler = { match : handler };
							}

							handler.match();
						});
					}

					return this;
				},

				unregister : function(q, handler) {
					return this
				}
			};

			return new Shim();
		}
	}]
});
